import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { combineLatest, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { EditorBookingItemSettingPricing } from '../editor-booking-item-setting/editor-booking-item-setting-pricing.model';
import { EditorDataService } from '../editor-data/editor-data.service';


@Component({
    selector: 'eas-editor-booking-item-setting-summary-pricing',
    templateUrl: './editor-booking-item-setting-summary.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditorBookingItemSettingSummaryPricingComponent implements OnChanges, OnInit, OnDestroy {
  @Input() itemSetting: EditorBookingItemSettingPricing;
  @Input() first: boolean;
  @Input() last: boolean;

  private destroyed$ = new Subject<void>();

  currencyNames: { id: string, name: string }[];
  paymentMethodNames: { id: string, name: string }[];

  summary: string;

  constructor(private editorData: EditorDataService) {

  }

  ngOnInit() {
    combineLatest(this.editorData.currencyNames$, this.editorData.paymentMethodNames$)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(([currencyNames, paymentMethodNames]) => {
        this.currencyNames = currencyNames;
        this.paymentMethodNames = paymentMethodNames;
        this.summary = this.getSummary();
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.itemSetting) {
      if (this.currencyNames !== undefined && this.paymentMethodNames !== undefined ) {
        this.summary = this.getSummary();
      }
    }
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  getSummary(): string {
    let summary = '';

    if (this.itemSetting.price !== null) {
      summary = `${this.itemSetting.price} ${this.itemSetting.getCurrencyName(this.currencyNames)}`;
    }

    if (this.itemSetting.methods.length > 0) {
      summary = $localize `${summary}, paid via ${this.itemSetting.getMethodsAsString(this.paymentMethodNames)}`;
    }

    if (summary === '') {
      return summary;
    }

    summary = this.first ? summary.charAt(0).toUpperCase() + summary.slice(1) : summary;
    if (!this.last) {
      summary = `${summary}, `;
    }

    return summary;
  }
}
